"use client";
import { ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";

const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisible = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener("scroll", toggleVisible);
        return () => window.removeEventListener("scroll", toggleVisible);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <button
            onClick={scrollToTop}
            className={`fixed bottom-8 right-8 z-50 rounded-full p-[2px]  bg-linear-to-b from-[#ffffff] to-[#74EAF8] shadow-lg shadow-[#74EAF8]/50 transition-opacity duration-300 cursor-pointer
  ${visible ? "opacity-100" : "opacity-0"} glow-bounce hover:animate-none`}
            aria-label="Scroll to top"
        >
            <span className="p-3 sm:p-[0.8vw] bg-black flex items-center justify-center rounded-full">
                <ChevronUp className="text-white size={20} sm:size-[1.5vw]" /></span>
        </button>

    );
};

export default ScrollToTopButton;
